var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 49,
    viewBox: "0 0 42 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.378 6.42939L8.03907 6.21489C6.27895 6.05346 4.94116 4.59582 5.05294 2.96122C5.16473 1.32662 6.68395 0.131003 8.44408 0.292429L36.0789 2.8269C37.839 2.98833 39.1768 4.44597 39.065 6.08057C38.9533 7.71517 37.434 8.91079 35.6739 8.74936L32.8108 8.48677C33.2671 9.257 33.5093 10.2195 33.4424 11.2392L33.4238 11.5225C33.1657 15.456 33.1657 15.456 28.4594 19.304C28.2027 19.514 27.9319 19.7354 27.6463 19.9695L23.4163 22.8036L27.2031 26.6969C27.7444 27.3113 28.2259 27.8508 28.6538 28.3302C32.0698 32.1579 32.0698 32.1579 31.828 35.8442L31.8094 36.1276C31.7451 37.1071 31.4054 37.9809 30.8895 38.646L33.2293 38.8606C34.9894 39.022 36.3272 40.4797 36.2154 42.1143C36.1036 43.7489 34.5844 44.9445 32.8243 44.7831L5.18946 42.2486C3.42934 42.0872 2.09155 40.6295 2.20333 38.9949C2.31511 37.3603 3.83434 36.1647 5.59447 36.3261L8.4577 36.5887C8.00112 35.8182 7.75867 34.8555 7.82553 33.8364L7.84413 33.5531C7.94858 31.9611 8.00795 31.0564 8.35349 30.2901C8.90831 29.0597 10.2009 28.1862 13.6026 25.3977L17.8516 22.272L14.0456 18.6723C11.0482 15.2707 9.89269 14.0516 9.51098 12.6454C9.27341 11.7703 9.33559 10.8227 9.44 9.23137L9.45859 8.94799C9.5229 7.9679 9.86239 7.09426 10.378 6.42939Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.196777,
    y: 0.277832,
    width: 40.8747,
    height: 48.5199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.842d0f03.svg";
export { ForwardRef as ReactComponent };